import { useGetFleetTypes } from '@jucy-ui/common';
import { MandatoryProduct } from '@jucy/rentals-api-client/rentals-api-v3/models/MandatoryProduct';
import { FleetCategory } from '@jucy/rentals-api-client/rentals-api/models/FleetCategory';

export const useMapLegacyFleetCategory = (fleetCategory?: FleetCategory) => {
    const { data: fleetTypes, isLoading } = useGetFleetTypes();
    const fleetType = fleetTypes?.find((fleetType) => fleetType.id === fleetCategory?.type);
    if (!fleetType || !fleetCategory) {
        return { data: null, isLoading };
    }
    return {
        data: {
            name: fleetCategory.name,
            description: fleetCategory.description,
            code: fleetCategory.categoryCode,
            categoryCode: fleetCategory.categoryCode,
            campaignCode: fleetCategory.campaignCode,
            campaignId: fleetCategory.campaignId,
            id: fleetCategory.id,
            type: fleetCategory.type,
            rentalDays: fleetCategory.rentalDays,
            dealText: fleetCategory.dealText,
            fleetTypeCode: fleetType.slug,
            availabilityMessage: '',
            dailyRate: fleetCategory.dailyRate,
            total: fleetCategory.total,
            discountPercentageApplied: fleetCategory.discountPercentageApplied,
            mandatoryFees: fleetCategory.mandatoryFees ? (fleetCategory.mandatoryFees as MandatoryProduct[]) : undefined,
            minimumHirePeriod: fleetCategory.minimumHirePeriod ? Number(fleetCategory.minimumHirePeriod) : undefined,
            isAfterHourPickUp: fleetCategory.isAfterHourPickUp,
            availability: fleetCategory.availability,
        },
        isLoading,
    };
};
